<template>
  <DialogWrapper
    class="resource-uploader"
    :show.sync="isShow"
    :loading="loading"
    :close-on-click-modal="false"
    :title="title"
    :showClose="false"
    :appendToBody="appendToBody"
    closeOnCancel
    @save="handelConfirm"
    @cancel="handelCancel"
  >
    <Uploader
      v-model="fileValue"
      class="video-uploader"
      ref="videoUploader"
      :file-type="FILE_TYPE.VIDEO"
      :accept-file-size="400"
      :file-key-generator="(file) => generateFileKey(file)"
      :label="$t(`${i18nPrefix}.btn.customContent.addVideo`)"
      :placeholder="$t(`${i18nPrefix}.placeholder.customContent.videoSize`)"
    >
      <template #uploadIcon>
        <div class="btn-icon"></div>
      </template>
    </Uploader>
    <el-input
      v-model="videoName"
      class="video-name"
      :placeholder="$t(`${i18nPrefix}.placeholder.customContent.videoName`)"
    />
  </DialogWrapper>
</template>

<script>
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import { getFilePath } from '@/utils/qiniu'
import Uploader, { FILE_TYPE } from './uploader.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    DialogWrapper,
    Uploader
  },
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true
    },
    title: {
      type: String
    },
    appendToBody: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      FILE_TYPE,
      fileValue: null,
      i18nPrefix: 'admin.job.editor',
      videoName: null,
      loading: false
    }
  },
  computed: {
    isShow: {
      get () {
        return this.show
      },
      set (val) {
        this.$emit('update:show', val)
      }
    }
  },
  created () {

  },
  mounted () {
  },
  methods: {
    ...mapGetters('account', ['getCurrentAccount']),
    ...mapActions('resourceLibrary', ['uploadResourceToLibrary']),

    async handelConfirm () {
      if (!this.fileValue) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.resourceLibrary.requiredVideo`))
        return
      }
      if (!this.videoName) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.placeholder.customContent.videoName`))
        return
      }

      this.loading = true
      try {
        const originalFileName = this.$refs.videoUploader.currentFile?.name
        const fileKey = await this.$refs.videoUploader.uploadSelectedFile()
        const resourceInfo = {
          name: this.videoName,
          resource_url: getFilePath(fileKey),
          resource_type: 'video',
          original_file_name: originalFileName
        }
        await this.uploadResourceToLibrary(resourceInfo)

        this.$emit('uploaded')
        this.$emit('update:show', false)
      } finally {
        this.loading = false
      }
    },
    handelCancel () {
      this.$emit('update:show', false)
    },
    generateFileKey (file) {
      const account = this.getCurrentAccount()
      const fileKey = `resource_library/company/${account.company_id}/video/${new Date().valueOf()}`
      return fileKey
    }
  },
  watch: {
    show () {
      if (this.show) {
        this.fileValue = null
        this.videoName = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.resource-uploader {
  .video-uploader {
    overflow: hidden;

    ::v-deep .video-previewer {
      height: 500px;
    }

    ::v-deep .add-btn {
      border: 1px dashed #ccc;
      background-color: #fff;

      .btn-label {
        margin-top: 10px;
        color: #0096cc;
      }

      .btn-placeholder {
        color: #d0d0d0;
        font-size: 13px;
      }
    }

    .btn-icon {
      width: 80px;
      height: 80px;
      background-repeat: no-repeat;
      background-size: cover;
      background-image: url($baseDomain + 'static/image/icon_add_video.png');
    }
  }
  .video-name {
    margin-top: 25px;

    ::v-deep {
      .el-input__inner {
        border-radius: 4px;
        height: 36px;
        line-height: 36px;
      }
    }
  }
}
</style>
